module.exports = __webpack_public_path__ + "img/1546443989.c6c6734d.jpg";